import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-around;
  }
`;

export const LeftSide = styled.div`
  padding: 1.5rem 1rem;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px,
    rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px;
  width: 100%;

  @media (min-width: 768px) {
    width: 40%;
  }
`;

export const RightSide = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px,
    rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px;
  max-width: 320px;
  width: 100%;
  padding: 1.5rem 1rem;
  margin-top: 2rem;

  @media (min-width: 768px) {
    margin-top: 0rem;
  }
`;

export const TitleCard = styled.div`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
`;

export const ContentAboutUser = styled.div`
  margin-top: 1rem;
`;

export const HeaderAboutUser = styled.div`
  display: flex;
`;

export const PictureUser = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
  margin-right: 1rem;
`;

export const DataUser = styled.div`
  div:nth-child(2) {
    margin-top: 1rem;
  }
`;

export const Item = styled.div`
  span {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.gray};
  }

  p {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.primary};
    padding-top: 0.5rem;
  }
`;

export const OtherItems = styled.div`
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 15px;
  column-gap: 10px;

  button {
    margin-top: 0.5rem;
    height: 35px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;

  div + div {
    margin-top: 1rem;
  }

  button {
    margin-top: 2rem;
  }
`;
